import { InjectionToken } from '@angular/core';
import { DepartmentsPort } from './departments.port';

export const DEPARTMENTS_PORT = new InjectionToken<DepartmentsPort>('DEPARTMENTS_PORT');